import type * as FormModelType from "@/components/features/setup/model/type";

export const serverModelToInputModelConverter = (): FormModelType.SetupFormModel["InputModel"] =>
	({
		hotelName: "",
		hotelEmailAddress: "",
		totalRoomNum: 10,
	}) satisfies FormModelType.SetupFormModel["InputModel"];
